module.exports = __webpack_public_path__ + "img/logosintropatos.9b10d9cc.png";